import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../common-service';

import { BookCostManagerStruct } from '../../structs/book-cost-manager.struct';
import { BookCostManagerListResponse } from '../../responses/platform/book-cost-manager-list.response';
import { BookCostCalculationResponse } from '../../responses/platform/book-cost-calculation.response';
import { ReturnStruct } from '../../structs/return.struct';

@Injectable({
  providedIn: 'root'
})
export class BookCostManagerService extends CommonService {
  constructor(private http: HttpClient) {
    super();
  }

  /**
   * Retorna todas as configurações de custos
   */
  public getAll(): Observable<BookCostManagerListResponse> {
    return this.http
      .get<BookCostManagerListResponse>(
        environment.urlApiPlatform + 'BookCostManager',
        this.addHeaderToken()
      )
      .pipe(catchError(this.handleError));
  }

  /**
   * Cria ou atualiza configuração
   */
  public save(request: BookCostManagerStruct): Observable<ReturnStruct> {
    return this.http
      .post<ReturnStruct>(
        environment.urlApiPlatform + 'BookCostManager/save',
        request,
        this.addHeaderToken()
      )
      .pipe(catchError(this.handleError));
  }

  /**
   * Calcula valores de custo/margens baseado no idBookVersion
   */
  public calculate(idBookVersion: number): Observable<BookCostCalculationResponse> {
    return this.http
      .get<BookCostCalculationResponse>(
        environment.urlApiPlatform + `BookCostManager/calculate/idBookVersion/${idBookVersion}`,
        this.addHeaderToken()
      )
      .pipe(catchError(this.handleError));
  }
}
